"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSplitPrice = void 0;
var number_1 = require("./number");
var getSplitPrice = function (value) {
    if (!value) {
        return undefined;
    }
    var priceNumber = (0, number_1.getNumber)(value);
    if (priceNumber === undefined) {
        return undefined;
    }
    var splitNumber = String(priceNumber).split(".");
    var valueArray = value.split("");
    // 货币符号
    var currency = valueArray[0];
    // 整数
    var priceIntNumber = splitNumber[0];
    // 小数
    var priceFloatNumber = splitNumber[1] ? ".".concat(splitNumber[1]) : "";
    // 单位
    var unit = valueArray[valueArray.length - 1];
    return {
        currency: currency,
        priceIntNumber: priceIntNumber,
        priceFloatNumber: priceFloatNumber,
        unit: unit,
    };
};
exports.getSplitPrice = getSplitPrice;
